import React, { Component } from 'react'
import { Header } from 'semantic-ui-react'

class MainHeader extends Component {
  render() {
    return (
        <Header as='h1' id='main-header' >Mo' Jobs, Less Probs</Header>
    )
  }
}

export default MainHeader


// WEBPACK FOOTER //
// ./src/components/Header.js